

var _squid = require('squid');

var _wallet = require('xo-models/src/wallet');

/**
 * $CardartInstrument is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 *
 * Currently, $CardardInstrument is being used at:
 * - xo-review
 * - xo-select-fi
 * - xo-sidebar-manage-wallet
 * - xo-wallet
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CardArtInstrument', function () {
    var CARD = 'CARD';
    var BALANCE = 'BALANCE';
    var wallet = _wallet.$WalletModel.instance(_squid.$meta.token);

    var isCardArtEnable = function isCardArtEnable(fiMeta) {
        return fiMeta && fiMeta.cardArtEnabled();
    };

    /**
     * @param {Ojbect} instrument A future payment instrument
     * @returns {Object}
     */
    var normalizeFutureInstrument = function normalizeFutureInstrument(instrument) {
        return {
            id: instrument.instrument_id,
            type: instrument.type,
            cardArtUrl: wallet.getCardArt(instrument)
        };
    };

    /**
     * @param {Object} options
     * @param {Object} otpions.primaryFs A primaryFs funding options
     * @returns {Object}
     */
    var normalizeFundingOptions = function normalizeFundingOptions(_ref) {
        var primaryFs = _ref.primaryFs;

        if (!primaryFs) {
            return {};
        }

        return {
            id: primaryFs.id,
            type: primaryFs.type,
            cardArtUrl: wallet.getCardArt(primaryFs)
        };
    };

    /**
     * @typedef {Object} FI
     * @property {String} fi_id
     * @property {String} fi_type
     * @property {String} is_cardart_shown
     * @property {String} eligible
     *
     * @typedef {Object} CardartInstrumentation
     * @property {Array<FI>} fi
     *
     * @param {Object} options
     * @param {Array} options.plans An array of fundingOptions plans or future payment instruments
     * @returns {Object<CardartInstrumentation>}
     */
    var normalizePayload = function normalizePayload(_ref2) {
        var _ref2$plans = _ref2.plans,
            plans = _ref2$plans === undefined ? [] : _ref2$plans;
        return {
            fi: plans.filter(function (plan, index, arr) {
                var id = arr.map(function (item) {
                    return item.id;
                });

                return index === id.indexOf(plan.id) && plan.type !== BALANCE;
            }).map(function (_ref3) {
                var id = _ref3.id,
                    type = _ref3.type,
                    cardArtUrl = _ref3.cardArtUrl;
                return {
                    fi_id: id,
                    fi_type: 'fi_' + (type && type.toLowerCase()),
                    is_cardart_shown: type === CARD && cardArtUrl ? '1' : '0',
                    eligible: type === CARD && cardArtUrl ? 'cardart' : null
                };
            })
        };
    };

    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Array}
     */
    var getSelectedInstrument = function getSelectedInstrument(_ref4) {
        var checkoutSession = _ref4.checkoutSession;

        return checkoutSession.getSelectedStickyInstrument() ? [checkoutSession.getSelectedStickyInstrument()].map(normalizeFutureInstrument) : [];
    };

    /**
     * CreatePayload creates cardart instrumentation based on the following criteria:
     *
     * - showMultipleFiVariants pxp
     * - showMultipleFiVariants + 3FI pxp
     * - singleFI pxp
     *
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @param {Boolean} options.isBillingNoPurchase $CheckoutCartModel.isBillingNoPurchase()
     * @param {Boolean} options.stickyEligible Default to be false
     * @param {Boolean} options.renderMultipleFi Determines whether to render multiple FIs or not
     * @param {Boolean} options.renderSingleFi Determines whether to render single FI or not
     * @param {Object} options.showMoreFiState ShowMoreFiState to determine whether we renders `Show More` expereience or not.
     * See $ShowMoreFiFactory.get() for details implementation
     * @returns {Object<CardartInstrumentation>}
     */
    var createPayload = function createPayload(_ref5) {
        var checkoutSession = _ref5.checkoutSession,
            isBillingNoPurchase = _ref5.isBillingNoPurchase,
            _ref5$stickyEligible = _ref5.stickyEligible,
            stickyEligible = _ref5$stickyEligible === undefined ? false : _ref5$stickyEligible,
            _ref5$renderMultipleF = _ref5.renderMultipleFi,
            renderMultipleFi = _ref5$renderMultipleF === undefined ? false : _ref5$renderMultipleF,
            _ref5$renderSingleFi = _ref5.renderSingleFi,
            renderSingleFi = _ref5$renderSingleFi === undefined ? false : _ref5$renderSingleFi,
            _ref5$showMoreFiState = _ref5.showMoreFiState,
            showMoreFiState = _ref5$showMoreFiState === undefined ? {
            eligible: false,
            isTooManyFi: false,
            isShowMoreBtnClicked: false
        } : _ref5$showMoreFiState;
        var eligible = showMoreFiState.eligible,
            isTooManyFi = showMoreFiState.isTooManyFi,
            isShowMoreBtnClicked = showMoreFiState.isShowMoreBtnClicked;

        var plans = isBillingNoPurchase ? checkoutSession.get('futurePaymentInstruments', []).map(normalizeFutureInstrument) : (checkoutSession.getPlanList() || []).map(normalizeFundingOptions);

        // when we do decide to render multiple FIs experience
        if (renderMultipleFi) {
            plans = eligible && isTooManyFi // eslint-disable-line no-nested-ternary
            ? isShowMoreBtnClicked ? plans.slice(0) // If `addMore` action has been triggered, we log all FIs
            : plans.slice(0, 3) // otherwise, we only log the first 3FIs
            : plans;
        } else if (renderSingleFi) {
            // Or, render a single FI experience
            // ensure we check if we have a sticky plan
            if (stickyEligible) {
                plans = getSelectedInstrument({ checkoutSession: checkoutSession });
            } else {
                plans = plans.slice(0, 1);
            }
        }

        return normalizePayload({ plans: plans });
    };

    return {
        createPayload: createPayload,
        isCardArtEnable: isCardArtEnable
    };
});

_squid.$meta;

_wallet.$WalletModel;


//////////////////
// WEBPACK FOOTER
// ./pages/services/cardart-instrument/index.js
// module id = ./pages/services/cardart-instrument/index.js
// module chunks = main-code-split